<template id="promo-challenge-cards">
    <ChallengeSectionContainer v-bind:isBigContainer="isBigContainer"
                               class="promo-challenge-container"
                               v-if="challengeList.length"
                               v-bind:key="challengeList.length" >
        <ChallengeCard v-for="challenge in challengeList"
                       v-bind:key="challenge.id"
                       class="jackpot-challenge"
                       v-bind:isBigContainer="isBigContainer"
                       v-bind:src="challenge.challenge_image"
                       v-bind:title="challenge.challenge_name"
                       v-bind:type="getType(challenge)"
                       v-bind:potValue="getPotValue(challenge)"
                       v-bind:betValue="getBetValue(challenge)"
                       v-bind:teamSize="getTeamSize(challenge)"
                       v-bind:dateRange="dateRangeOf(challenge)"
                       v-bind:signUpUrl="challenge.challenge_landing_page" />
    </ChallengeSectionContainer>
</template>

<script>
import GeneralChallengeCards, { parsedPotValue } from './GeneralChallengeCards';
import ChallengeSectionContainer from './card/ChallengeSectionContainer';
import ChallengeCard from './card/ChallengeCard';

export default {
  template: '#promo-challenge-cards',
  mixins: [GeneralChallengeCards],
  components: { ChallengeSectionContainer, ChallengeCard },
  computed: {
    challengeList: function() {
      return filterPromoChallenges(this.$store.state.fullFilteredChallengeList)
    }
  },
  methods: {
    getPotValue: function(challenge) {
      var value = parsedPotValue(challenge.top_price_currency, challenge.top_price); // jackpot as default

      if (isChallengeType(challenge, 'team')) {
        value = parsedPotValue(challenge.prize.first_prize_currency, challenge.prize.first_prize).concat(' top prize!');
      }

      return value;
    }
  }
}

export function filterPromoChallenges(challengeList) {
  return challengeList.filter(function(challenge) { return challenge.is_org_challenge })
}

export function isChallengeType(challenge, type) {
  return challenge.challenge_type.includes(type)
}

</script>
